export default __webpack_public_path__ + "static/media/11.6.dcc52b23.jpg";